<closeable-dialog class="drone-dialog-container" [displayFooter]="showFooter">
  <div class="dialog-header title" dialog-card-header><label>{{ 'droneInformation' | translate }} : {{droneId}} </label> </div>

  <div dialog-card-body class="dialog-body full-height">
    <div class="centered-image">
      <img class="img1" src="assets/images/drone.png" width="200" height="200" />
    </div>
    <nb-tabset (changeTab)="onTabChange($event)">
      <nb-tab tabTitle="{{'summary' | translate}}" [active]="activeTab === 'summary'" [tabId]="'summary'">
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title">{{'General Information' | translate}} : </label>
          </div>
        </div>


        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title">{{'droneId' | translate}} : </label>
            <label class="column-info content">{{droneId}}</label>
          </div>
          <div class="flex-50">
            <label class="column-info title"> {{'brand' | translate}} :</label>
            <label class="column-info content">{{brand}}</label>
          </div>
        </div>

        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title">{{'model' | translate}} : </label>
            <label class="column-info content">{{model}}</label>
          </div>
          <div class="flex-50">
            <label class="column-info title"> {{'certificateDate' | translate}} :</label>
            <label class="column-info content">{{certificateDate}}</label>
          </div>
        </div>
      </nb-tab>
    </nb-tabset>
  </div>
  <div dialog-card-footer class="footer">
    <div dialog-card-footer class="footer-left">
      <label class="column-info title">{{'coordinate' | translate}}: </label>
      <label class="column-info content">{{'-'}} </label>
    </div>
  </div>
</closeable-dialog>


